import { DonateButton } from "~/common/charity/DonateButton";
import { FavoriteButton } from "~/common/charity/FavoriteButton";
import { buildUrl } from "~/utils/url";

export const ListItemFooter = ({
  listId,
  name,
  ein,
  isFavorite,
}: {
  listId: string;
  name: string;
  ein: string;
  isFavorite: boolean;
}) => {
  const handleDonate = (e: React.MouseEvent<HTMLButtonElement>) => {
    console.log("DonateButton: opening donate modal");
    window.cnDonateListModal(ein, name, listId);
    e.stopPropagation();
  };

  const handleFavorite = (e: React.MouseEvent<HTMLDivElement>) => {
    //navigate to favorite url
    const baseUrl = Environment.CN_URL;
    const favoriteUrl = buildUrl(baseUrl, `/profile/favorites/add/${ein}`);
    console.log("Navigating to favorite URL", favoriteUrl);
    window.location.href = favoriteUrl;

    e.stopPropagation();
  };

  return (
    <div className="tw:flex tw:flex-row tw:justify-between tw:items-center tw:!border-t-1 tw:!border-t-gray-100 tw:mt-2">
      <DonateButton
        size={"md"}
        enabled={true}
        loading={false}
        onClick={handleDonate}
      />
      <FavoriteButton
        selected={isFavorite}
        theme={"light"}
        onClick={handleFavorite}
      />
    </div>
  );
};
